import { LOT } from '../types/lot.js';
import { validateLot } from '../validators/validateLot.js';
import { OrgScopedCrudService } from './OrgScopedCrudService.js';
export const lotService = new OrgScopedCrudService({
    collection: 'lot',
    entity: LOT,
    lifecycle: true,
    validate: validateLot,
    sort: (a, b) => (a.lotNumber ?? '').localeCompare(b.lotNumber ?? ''),
});
//# sourceMappingURL=lotService.js.map